import React, { useState } from 'react';
import { useIntl } from '../../../../util/reactIntl';
import css from './CustomFAQ.module.css';

const CustomFAQ = () => {
  const intl = useIntl();
  const [openItems, setOpenItems] = useState({});

  // FAQ data using translations
  const faqData = [
    {
      category: intl.formatMessage({ id: 'FAQSectionEnhancer.categoryBuying' }),
      items: [
        {
          question: intl.formatMessage({ id: 'FAQSectionEnhancer.questionBuyerFees' }),
          answer: intl.formatMessage({ id: 'FAQSectionEnhancer.answerBuyerFees' })
        },
        {
          question: intl.formatMessage({ id: 'FAQSectionEnhancer.questionReturns' }),
          answer: intl.formatMessage({ id: 'FAQSectionEnhancer.answerReturns' })
        },
        {
          question: intl.formatMessage({ id: 'FAQSectionEnhancer.questionHowToBuy' }),
          answer: intl.formatMessage({ id: 'FAQSectionEnhancer.answerHowToBuy' })
        },
        {
          question: intl.formatMessage({ id: 'FAQSectionEnhancer.questionDeliveryTime' }),
          answer: intl.formatMessage({ id: 'FAQSectionEnhancer.answerDeliveryTime' })
        },
        {
          question: intl.formatMessage({ id: 'FAQSectionEnhancer.questionShippingCost' }),
          answer: intl.formatMessage({ id: 'FAQSectionEnhancer.answerShippingCost' })
        },
        {
          question: intl.formatMessage({ id: 'FAQSectionEnhancer.questionLocalPickup' }),
          answer: intl.formatMessage({ id: 'FAQSectionEnhancer.answerLocalPickup' })
        },
        {
          question: intl.formatMessage({ id: 'FAQSectionEnhancer.questionWhyNoCash' }),
          answer: intl.formatMessage({ id: 'FAQSectionEnhancer.answerWhyNoCash' })
        },
        {
          question: intl.formatMessage({ id: 'FAQSectionEnhancer.questionWhatIsWantedGear' }),
          answer: intl.formatMessage({ id: 'FAQSectionEnhancer.answerWhatIsWantedGear' })
        },
        {
          question: intl.formatMessage({ id: 'FAQSectionEnhancer.questionWhoCanUseWantedGear' }),
          answer: intl.formatMessage({ id: 'FAQSectionEnhancer.answerWhoCanUseWantedGear' })
        }
      ]
    },
    {
      category: intl.formatMessage({ id: 'FAQSectionEnhancer.categoryGeneral' }),
      items: [
        {
          question: intl.formatMessage({ id: 'FAQSectionEnhancer.questionWhatCanISell' }),
          answer: intl.formatMessage({ id: 'FAQSectionEnhancer.answerWhatCanISell' })
        },
        {
          question: intl.formatMessage({ id: 'FAQSectionEnhancer.questionWhatIsBirdieChance' }),
          answer: intl.formatMessage({ id: 'FAQSectionEnhancer.answerWhatIsBirdieChance' })
        }
      ]
    },
    {
      category: intl.formatMessage({ id: 'FAQSectionEnhancer.categorySelling' }),
      items: [
        {
          question: intl.formatMessage({ id: 'FAQSectionEnhancer.questionSellingCost' }),
          answer: intl.formatMessage({ id: 'FAQSectionEnhancer.answerSellingCost' })
        },
        {
          question: intl.formatMessage({ id: 'FAQSectionEnhancer.questionWhenPaid' }),
          answer: intl.formatMessage({ id: 'FAQSectionEnhancer.answerWhenPaid' })
        }
      ]
    }
  ];

  const toggleItem = (categoryIndex, itemIndex) => {
    const key = `${categoryIndex}-${itemIndex}`;
    setOpenItems(prev => ({
      ...prev,
      [key]: !prev[key]
    }));
  };

  const renderAnswer = (answerText) => {
    const linkMatch = answerText.match(/\{(\w+)\}/);

    if (linkMatch) {
      const linkKey = linkMatch[1];
      const linkTextKey = `FAQSectionEnhancer.${linkKey}`;
      const linkUrlKey = `FAQSectionEnhancer.${linkKey}Url`;

      const linkText = intl.formatMessage({ id: linkTextKey });
      const linkUrl = intl.formatMessage({ id: linkUrlKey });

      const parts = answerText.split(linkMatch[0]);

      return (
        <>
          {parts.map((part, index) => (
            <React.Fragment key={index}>
              {part.split('\n\n').map((paragraph, pIndex) =>
                paragraph.trim() && <p key={pIndex} className={css.paragraph}>{paragraph.trim()}</p>
              )}
              {index < parts.length - 1 && (
                <a
                  href={linkUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={css.link}
                >
                  {linkText}
                </a>
              )}
            </React.Fragment>
          ))}
        </>
      );
    }

    return answerText.split('\n\n').map((paragraph, index) =>
      paragraph.trim() && <p key={index} className={css.paragraph}>{paragraph.trim()}</p>
    );
  };

  return (
    <div className={css.faqContainer}>
      {faqData.map((category, categoryIndex) => (
        <div key={categoryIndex} className={css.faqCategory}>
          <h3 className={css.faqCategoryTitle}>{category.category}</h3>
          <div className={css.faqCategoryContainer}>
            {category.items.map((item, itemIndex) => {
              const key = `${categoryIndex}-${itemIndex}`;
              const isOpen = openItems[key];

              return (
                <div key={itemIndex} className={css.faqItem}>
                  <button
                    className={`${css.faqQuestion} ${isOpen ? css.active : ''}`}
                    onClick={() => toggleItem(categoryIndex, itemIndex)}
                  >
                    <span>{item.question}</span>
                    <span className={`${css.faqIcon} ${isOpen ? css.rotated : ''}`}>▼</span>
                  </button>
                  <div className={`${css.faqAnswer} ${isOpen ? css.open : ''}`}>
                    <div className={css.faqAnswerContent}>
                      {renderAnswer(item.answer)}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
};

export default CustomFAQ;
